 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~confounder~covid-cancer~covid-xqtl~cypher~drugs-risk-factors~explore~genetic-cor~literature-tr~5ba60d91":"about~confounder~covid-cancer~covid-xqtl~cypher~drugs-risk-factors~explore~genetic-cor~literature-tr~5ba60d91","about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad":"about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad","covid-xqtl~multi-ancestry-pwmr~pqtl-view~sc-eqtl-mr":"covid-xqtl~multi-ancestry-pwmr~pqtl-view~sc-eqtl-mr","covid-xqtl":"covid-xqtl","multi-ancestry-pwmr":"multi-ancestry-pwmr","sc-eqtl-mr":"sc-eqtl-mr","about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c":"about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c","about~confounder~drugs-risk-factors~galleryPlot~genetic-cor~literature-trait~mr~obs-cor~ontology-tra~79ed93bf":"about~confounder~drugs-risk-factors~galleryPlot~genetic-cor~literature-trait~mr~obs-cor~ontology-tra~79ed93bf","about":"about","confounder":"confounder","drugs-risk-factors":"drugs-risk-factors","genetic-cor":"genetic-cor","literature-trait":"literature-trait","mr":"mr","obs-cor":"obs-cor","ontology-trait-disease":"ontology-trait-disease","pathway":"pathway","prs":"prs","xqtl":"xqtl","cypher":"cypher","covid-cancer":"covid-cancer","explore":"explore","entity~meta-node~meta-relationship":"entity~meta-node~meta-relationship","meta-node":"meta-node","meta-relationship":"meta-relationship","nlp":"nlp","pqtl-view":"pqtl-view","galleryPlot":"galleryPlot","covid":"covid","demo":"demo","drugs":"drugs","entity":"entity","gallery":"gallery","literature":"literature","ontology":"ontology","pairwise-rels":"pairwise-rels","pqtl-home":"pqtl-home","pqtl-list":"pqtl-list","table-demo":"table-demo"}[chunkId]||chunkId) + "." + {"about~confounder~covid-cancer~covid-xqtl~cypher~drugs-risk-factors~explore~genetic-cor~literature-tr~5ba60d91":"e11958ea","about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad":"9367211e","covid-xqtl~multi-ancestry-pwmr~pqtl-view~sc-eqtl-mr":"7f2fe846","covid-xqtl":"28b2499d","multi-ancestry-pwmr":"f5e11e33","sc-eqtl-mr":"e0646543","about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c":"50d167ba","about~confounder~drugs-risk-factors~galleryPlot~genetic-cor~literature-trait~mr~obs-cor~ontology-tra~79ed93bf":"790cbcdf","about":"988d6ccd","confounder":"35c4cada","drugs-risk-factors":"b4a3a867","genetic-cor":"a8d63113","literature-trait":"e84365d7","mr":"40bcd233","obs-cor":"4a56362d","ontology-trait-disease":"317b0fac","pathway":"198702f0","prs":"ce68ef7e","xqtl":"3f5589a1","cypher":"1d484eeb","covid-cancer":"b8641cea","explore":"4de29065","entity~meta-node~meta-relationship":"0dc1e803","meta-node":"1c053301","meta-relationship":"6afb45ce","nlp":"d690aa5c","pqtl-view":"00cc7ecb","galleryPlot":"4928e4b2","covid":"f3bed4eb","demo":"99c263fc","drugs":"b5b41137","entity":"c68741bc","gallery":"ed0b61b2","literature":"435e1ce7","ontology":"cc1c2a52","pairwise-rels":"11237ff2","pqtl-home":"8f51598c","pqtl-list":"47a2b7b8","table-demo":"cd5775b1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad":1,"covid-xqtl":1,"multi-ancestry-pwmr":1,"sc-eqtl-mr":1,"about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c":1,"about":1,"confounder":1,"drugs-risk-factors":1,"genetic-cor":1,"literature-trait":1,"mr":1,"obs-cor":1,"ontology-trait-disease":1,"pathway":1,"prs":1,"xqtl":1,"cypher":1,"covid-cancer":1,"explore":1,"entity~meta-node~meta-relationship":1,"meta-node":1,"meta-relationship":1,"nlp":1,"pqtl-view":1,"galleryPlot":1,"entity":1,"gallery":1,"pqtl-home":1,"pqtl-list":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~confounder~covid-cancer~covid-xqtl~cypher~drugs-risk-factors~explore~genetic-cor~literature-tr~5ba60d91":"about~confounder~covid-cancer~covid-xqtl~cypher~drugs-risk-factors~explore~genetic-cor~literature-tr~5ba60d91","about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad":"about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad","covid-xqtl~multi-ancestry-pwmr~pqtl-view~sc-eqtl-mr":"covid-xqtl~multi-ancestry-pwmr~pqtl-view~sc-eqtl-mr","covid-xqtl":"covid-xqtl","multi-ancestry-pwmr":"multi-ancestry-pwmr","sc-eqtl-mr":"sc-eqtl-mr","about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c":"about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c","about~confounder~drugs-risk-factors~galleryPlot~genetic-cor~literature-trait~mr~obs-cor~ontology-tra~79ed93bf":"about~confounder~drugs-risk-factors~galleryPlot~genetic-cor~literature-trait~mr~obs-cor~ontology-tra~79ed93bf","about":"about","confounder":"confounder","drugs-risk-factors":"drugs-risk-factors","genetic-cor":"genetic-cor","literature-trait":"literature-trait","mr":"mr","obs-cor":"obs-cor","ontology-trait-disease":"ontology-trait-disease","pathway":"pathway","prs":"prs","xqtl":"xqtl","cypher":"cypher","covid-cancer":"covid-cancer","explore":"explore","entity~meta-node~meta-relationship":"entity~meta-node~meta-relationship","meta-node":"meta-node","meta-relationship":"meta-relationship","nlp":"nlp","pqtl-view":"pqtl-view","galleryPlot":"galleryPlot","covid":"covid","demo":"demo","drugs":"drugs","entity":"entity","gallery":"gallery","literature":"literature","ontology":"ontology","pairwise-rels":"pairwise-rels","pqtl-home":"pqtl-home","pqtl-list":"pqtl-list","table-demo":"table-demo"}[chunkId]||chunkId) + "." + {"about~confounder~covid-cancer~covid-xqtl~cypher~drugs-risk-factors~explore~genetic-cor~literature-tr~5ba60d91":"31d6cfe0","about~confounder~covid-xqtl~drugs-risk-factors~genetic-cor~literature-trait~mr~multi-ancestry-pwmr~o~3960edad":"a7bbc042","covid-xqtl~multi-ancestry-pwmr~pqtl-view~sc-eqtl-mr":"31d6cfe0","covid-xqtl":"40dff3b2","multi-ancestry-pwmr":"40dff3b2","sc-eqtl-mr":"40dff3b2","about~confounder~cypher~drugs-risk-factors~genetic-cor~literature-trait~meta-node~meta-relationship~~8d565c2c":"014c6e75","about~confounder~drugs-risk-factors~galleryPlot~genetic-cor~literature-trait~mr~obs-cor~ontology-tra~79ed93bf":"31d6cfe0","about":"4dd79597","confounder":"28320545","drugs-risk-factors":"28320545","genetic-cor":"28320545","literature-trait":"28320545","mr":"6cfbce8b","obs-cor":"28320545","ontology-trait-disease":"7bc05e96","pathway":"28320545","prs":"28320545","xqtl":"28320545","cypher":"40dff3b2","covid-cancer":"6398d8aa","explore":"80e513f8","entity~meta-node~meta-relationship":"364ea07c","meta-node":"750f0d17","meta-relationship":"786edc09","nlp":"57033e92","pqtl-view":"b971ecb3","galleryPlot":"91c5f68a","covid":"31d6cfe0","demo":"31d6cfe0","drugs":"31d6cfe0","entity":"3bd8c167","gallery":"d11a026e","literature":"31d6cfe0","ontology":"31d6cfe0","pairwise-rels":"31d6cfe0","pqtl-home":"4e09de9d","pqtl-list":"40dff3b2","table-demo":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
